import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import usersService from "../../../services/UsersService";
import { updateUserInfo } from "../../../store/userInfo";
import InputCom from "../../Helpers/Inputs/InputCom";
import AuthLayout from "../AuthLayout";

// First-login step — same as myfit-app's CompleteProfileScreen: collects
// first/last name for a brand-new account (myfit-api's User row starts
// with both blank; /user/verify's profile_complete tells the caller
// whether this step is still needed). Reached only right after Login's
// verifyCode(), which stores the session token/email before navigating
// here — see Login/index.jsx.
export default function CompleteProfile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userApi = new usersService();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    const first = firstName.trim();
    const last = lastName.trim();
    if (!first || !last) {
      setErrorMessage("Enter your first and last name.");
      return;
    }
    setErrorMessage("");
    setLoading(true);
    try {
      const token = localStorage.getItem("session_token");
      await userApi.completeProfile(token, first, last);

      // Mirrors verifyCode()'s own profile shape (AuthRoute reads
      // `profile.firstname`, not `first_name`).
      const profile = {
        firstname: first,
        lastname: last,
        profile_complete: true,
      };
      localStorage.setItem("profile", JSON.stringify(profile));
      dispatch(updateUserInfo(profile));

      navigate("/", { replace: true });
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.error || "Could not save your name, please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout slogan="Welcome to myFit">
      <div className="content-wrapper w-full flex justify-center items-center xl:bg-white dark:bg-dark-white 2xl:w-[828px] xl:w-[500px] 2xl:h-[818px] xl:h-[600px] rounded-xl 2xl:px-[164px] xl:px-[56px] sm:px-7 px-5">
        <div className="w-full">
          <div className="title-area flex flex-col justify-center items-center relative text-center mb-7">
            <h1 className="text-4xl font-bold leading-[54px] text-dark-gray dark:text-white">
              Tell us about you
            </h1>
            <p className="text-base text-thin-light-gray font-normal mt-2">
              Just your name, so we know what to call you.
            </p>
          </div>
          <form className="input-area" onSubmit={onSubmit}>
            <div className="input-item mb-6">
              <InputCom
                value={firstName}
                inputHandler={(e) => setFirstName(e.target.value)}
                placeholder="First name"
                label="First Name"
                name="firstName"
                type="text"
              />
            </div>
            <div className="input-item mb-7">
              <InputCom
                value={lastName}
                inputHandler={(e) => setLastName(e.target.value)}
                placeholder="Last name"
                label="Last Name"
                name="lastName"
                type="text"
              />
            </div>

            <div className="signin-area mb-3.5">
              <div className="flex justify-center">
                <button
                  type="submit"
                  className={`btn-login rounded-[50px] mb-6 text-xl text-white font-bold flex justify-center bg-purple items-center ${
                    loading ? "active" : ""
                  }`}
                >
                  {loading ? (
                    <div className="signup btn-loader"></div>
                  ) : (
                    <span>Continue</span>
                  )}
                </button>
              </div>
              {errorMessage && (
                <p className="text-center text-red-700 pb-4">{errorMessage}</p>
              )}
            </div>
          </form>
        </div>
      </div>
    </AuthLayout>
  );
}
